<template>
    <div>
        <card-header title="Edit Event Description" icon="fa-pencil"/>

        <card-body>
            <card-list v-if="notFound">
                <container-list-item padded>
                    <i class="fas fa-exclamation-triangle mr-2"></i>This event description no longer exists. It may have been deleted.
                </container-list-item>
            </card-list>
            <event-description-form v-if="!notFound" :description="description"/>
        </card-body>

        <card-footer class="pt-3 pb-3" v-if="!notFound">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteDescription"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Description?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" :disabled="!description.title || !description.description" @click="submit"><i class="fas fa-check mr-2"></i>Save Description</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardList from "@/TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import EventDescriptionForm from "./EventDescriptionForm";

    import {client as http} from '@/http_client';

    export default {
        props: ['card', 'child', 'props'],
        components: {EventDescriptionForm, ContainerListItem, CardFooter, CardBody, CardList, CardHeader},
        data: function() {
            return {
                description: {},
                confirmDelete: false,
                dirty: null,
                notFound: false
            };
        },
        methods: {
            loadDescription() {
                this.$emit('loading', true);
                this.notFound = false;
                http.get('/api/event_descriptions/' + this.props.descriptionId, {force: true}).then(response => {
                    this.description = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    this.notFound = true;
                    this.$emit('loading', false);
                });
            },
            submit() {
                this.$emit('loading', true);
                http.put('/api/event_descriptions/' + this.props.descriptionId, this.description, {force: true}).then(response => {
                    this.$reloadCard('event-descriptions');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    this.$emit('loading', false);
                });
            },
            deleteDescription() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);
                    http.delete('/api/event_descriptions/' + this.props.descriptionId).then(response => {
                        this.$reloadCard('event-descriptions');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {
                        this.$emit('loading', false);
                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.descriptionId': function() {
                this.dirty = null;
                this.loadDescription();
            },
            'description': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this event description? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadDescription();
        }
    };
</script>
